/**
 * Represents the status of a community.
 * @see https://github.com/jebelapp/jebel/issues/1728
 */
export var CommunityStatus;
(function (CommunityStatus) {
    CommunityStatus["InvitationSent"] = "InvitationSent";
    CommunityStatus["Active"] = "Active";
    CommunityStatus["Inactive"] = "Inactive";
})(CommunityStatus || (CommunityStatus = {}));
/**
 * Represents the registration policy for a community.
 * Controls how new members can join the community.
 */
export var RegistrationPolicy;
(function (RegistrationPolicy) {
    /** Anyone can join immediately. */
    RegistrationPolicy["Open"] = "Open";
    /** New members must be approved by an community administrator. */
    RegistrationPolicy["ApprovalRequired"] = "ApprovalRequired";
})(RegistrationPolicy || (RegistrationPolicy = {}));
